import { tiendasApi } from '../api'

export const mobbexSuscriptorApiSlice = tiendasApi.injectEndpoints({
    endpoints: builder => ({
        createSuscriptor: builder.mutation({
            query: ({body}) => ({
                url: 'web/pagotic/crear-suscripto',
                method: 'POST',
                body: body
            })
        }),
    })
})

export const {
    useCreateSuscriptorMutation,
} = mobbexSuscriptorApiSlice